import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService } from '../customer.service';

@Component({
  selector: 'app-update-customer',
  templateUrl: './update-customer.component.html',
  styleUrls: ['./update-customer.component.scss']
})
export class UpdateCustomerComponent implements OnInit {
  customerid: number;
  alert = false;
  id: string;
  public href = '';
  customerDetail: any = {
    'Id': 0,
    'FullName': '',
    'Mobile': '',
    'UrlImage': ''

  };

  constructor(private route: ActivatedRoute,
    private router: Router,
    private customerService: CustomerService) {
    this.customerid = this.route.snapshot.params['Id'];
    console.log('Customer id',  this.customerid);
   }

  ngOnInit() {
    this.EditCustomer();
    // this.customerid = this.route.snapshot.params['Id'];
    // console.log('customer id', this.customerid);


  }
  EditCustomer() {
    this.customerService.getCustomerbyId(this.customerid).subscribe(response => {
    this.customerDetail.FullName = response.FullName;
    this.customerDetail.Mobile = response.Mobile;
    // console.log(this.customerDetail);
    });
  }
  onSubmit() {
        this.customerDetail.Id = this.customerid;
        this.customerService.UpdateCustomer(this.customerDetail).subscribe((data: any) => {
          if (!data.id) {
            this.alert = true;
          }
          this.router.navigateByUrl('/customers/customers');
        });
  }

  func() {
    if (this.alert) {
    this.router.navigateByUrl('/customers/customers');
  }
  }

}
